module.exports = __webpack_public_path__ + "img/info-circle-solid.2d3089f6.svg";